module.exports = __webpack_public_path__ + "c9e905ababec97025f212658266adae5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-9.png
// module id = 1790
// module chunks = 0